import {apiCore} from "./apiCore";

const paymentGetFees = apiCore
    .injectEndpoints({
        endpoints: (build) => ({
            getPaymentFees: build.query({
                providesTags: ['payment-get-fees'],
                query: () => '/payment/service-fees/',
            }),
            sendPaymentFeesInfo: build.mutation({
                query: (arg) => ({
                    url: '/payment/pay-fee/',
                    body: {
                        feeCase: arg?.accreditation,
                        bank: arg?.bank,
                        usage: "web"
                    },
                    method: "POST",
                })
            })
        })
    })

export const {useGetPaymentFeesQuery, useSendPaymentFeesInfoMutation} = paymentGetFees
